import React from 'react';
import ArcPage from '../../../registration/view/ArcPage';
import i18n from '../../../../common/i18n';
import MinHeightPage from '../../../registration/view/MinHeightPage';
import { LoaderOrangeRings } from '../../../loaders/loaderOrangeRings/LoaderOrangeRings';

function ForcedActionStatusBlocked() {
    return (
        <MinHeightPage>
            <ArcPage.Top>
                <h1>{i18n('nui.registrationFinish.title.forcedActionStatus.blocked')}</h1>
            </ArcPage.Top>
            <ArcPage.Body>
                <div className="forced-actions text-left">
                    <div className="forced-actions-content">
                        <div className="forced-actions-loading mb-15">{i18n('nui.registration.common.loading')}</div>
                        <div className="my-32">
                            <LoaderOrangeRings />
                        </div>
                    </div>
                </div>
            </ArcPage.Body>
        </MinHeightPage>
    );
}

export default ForcedActionStatusBlocked;
